import FindResourceEntryInteractor from "../../core/interactor/app/crud/FindResourceEntryInteractor";
import { ICaseDecision } from "../model/CaseDecision";
import CaseDecisionMapper from "../service/CaseDecisionMapper";
import CaseDecisionParamMapper from "../service/CaseDecisionParamMapper";

export default class FindCaseDecisionInteractor {
  private resource: FindResourceEntryInteractor<ICaseDecision>;

  constructor({ findResourceEntry }: any) {
    this.resource = findResourceEntry;
  }

  async execute(id: string) {
    return this.resource.execute(
      "/case-decisions",
      CaseDecisionMapper,
      CaseDecisionParamMapper,
      id
    );
  }
}
